import { render, staticRenderFns } from "./ChangeSeqVendor.vue?vue&type=template&id=8571d1c8&"
import script from "./ChangeSeqVendor.vue?vue&type=script&lang=js&"
export * from "./ChangeSeqVendor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports